import { MoveStruct, ObjectOwner } from '@mysten/sui.js/src/client';
import { OwnedObject } from './OwnedObject';
import { KioskItem } from '@mysten/kiosk';

export type OwnedObjectType = KioskItem & {
  display: Record<string, string>;
  fields: MoveStruct;
  owner: ObjectOwner | undefined | null;
};

export function OwnedObjects({
  ownedSudoObjects,
  types,
}: {
  ownedSudoObjects: OwnedObjectType[];
  types: string[];
}) {
  const filteredObjects = ownedSudoObjects?.filter(object =>
    types.includes(object.type),
  );

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 pt-12">
      {/* Only shows item with an image_url to make it easier to understand the flows. */}
      {filteredObjects.length > 0 ? (
        filteredObjects?.map(item => (
          <OwnedObject key={item.objectId} object={item} />
        ))
      ) : (
        <div className="flex justify-center min-h-[300px] items-center h-full">
          {' '}
          You don't have any lootbox.{' '}
        </div>
      )}
    </div>
  );
}
